import React, { Fragment, useEffect, useState } from "react";
import PageTitle from "../../../layouts/PageTitle";
import * as Yup from "yup";
import CustomInput from "../../../Custom/CustomInput";
import { Field, FormikProvider, useFormik } from "formik";
import { Col, Form, Label, Row } from "reactstrap";
import CustomSelect from "../../../Custom/CustomSelect";
import defaultIcon from "../../../../images/avatar/500x500.png";
import { useHistory } from "react-router-dom";
import {} from "../../../Helper/url_helper";
import { get, post, postFormData } from "../../../Helper/api_helper";
import { Spin } from "antd";
import swal from "sweetalert";
import { t } from "i18next";

const StaffPayout = () => {
  const history = useHistory();

  var objLogin = JSON.parse(localStorage.getItem("userDetails"));

  const [isLoading, setIsLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    Month: Yup.string().required("Month is required field."),
    Year: Yup.string().required("Year is required field."),
    SalaryType: Yup.string().required("Salary Type is required field."),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      Month: "",
      Year: "",
      SalaryType: "",
    },
    validateOnBlur: false,
  });

  const {
    setFieldValue,
    setValues,
    handleValidSubmit,
    values: {},
  } = formik;

  const MonthOption = [
    { label: "January", value: 1 },
    { label: "February", value: 2 },
    { label: "March", value: 3 },
    { label: "April", value: 4 },
    { label: "May", value: 5 },
    { label: "June", value: 6 },
    { label: "July", value: 7 },
    { label: "August", value: 8 },
    { label: "September", value: 9 },
    { label: "October", value: 10 },
    { label: "November", value: 11 },
    { label: "December", value: 12 },
  ];
  const YearOption = [
    { label: "2023", value: 1 },
    { label: "2024", value: 2 },
    { label: "2025", value: 3 },
    { label: "2026", value: 3 },
  ];
  const SalaryTypeOption = [
    { label: "Hourly", value: 1 },
    { label: "Per Visit", value: 2 },
  ];

  return (
    <Fragment>
      <Spin size="large" spinning={isLoading} tip={"Loading..."}>
        <PageTitle activeMenu="Staff Payout" motherMenu="Transaction" />

        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="basic-form">
                  <FormikProvider value={formik}>
                    <Form onSubmit={formik.handleSubmit}>
                      <Row>
                        <Col lg={4}>
                          <Field
                            label={"Month"}
                            name="Month"
                            options={MonthOption}
                            component={CustomSelect}
                            required
                          />
                        </Col>
                        <Col lg={4}>
                          <Field
                            label={"Year"}
                            name="Year"
                            options={YearOption}
                            component={CustomSelect}
                            required
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4}>
                          <Field
                            label={"Salary Type"}
                            name="SalaryType"
                            options={SalaryTypeOption}
                            component={CustomSelect}
                            required
                          />
                        </Col>
                      </Row>
                      <br></br>
                      <button type="submit" className="btn mr-2 btn-primary">
                        Submit
                      </button>
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={(e) => {
                          history.push("/");
                        }}
                      >
                        Cancel
                      </button>
                    </Form>
                  </FormikProvider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Spin>
    </Fragment>
  );
};

export default StaffPayout;
